import { z } from 'zod/v4'
export const maturitySchema = z.enum(['labs', 'beta', 'stable'])
export type Maturity = z.infer<typeof maturitySchema>
